(function () {
  'use strict';

  if (window.PGCartOnwardStabilityV17) return;
  window.PGCartOnwardStabilityV17 = true;

  var MINI_CART_FORM = '.cart_content form[data-cart-form="mini-cart"]';
  var nativeReplaceWith = Element.prototype.replaceWith;
  var observer = null;
  var syncTimer = null;

  var PATCH_SELECTORS = [
    '.pg-drawer-shipbar',
    '[data-pg-reserved]',
    '.cart_content__continue-shopping',
    '.cart_items.js-cart_items',
    '.cart_discounts.js-cart_discounts',
    '.cart_subtotal.js-cart_subtotal',
    '.cart_savings.js-cart_savings',
    '.cart-message'
  ];

  function textOf(element) {
    return ((element && (
      element.value ||
      element.getAttribute('aria-label') ||
      element.innerText ||
      element.textContent
    )) || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function attributeText(element) {
    if (!element || element.nodeType !== 1) return '';

    var values = [
      element.id || '',
      typeof element.className === 'string' ? element.className : ''
    ];

    Array.prototype.forEach.call(element.attributes || [], function (attribute) {
      values.push(attribute.name || '', attribute.value || '');
    });

    return values.join(' ').toLowerCase();
  }

  function hasOnwardContext(element, boundary) {
    var current = element;

    while (current && current !== boundary && current.nodeType === 1) {
      if (/onward|checkoutplus|checkout-plus|checkout_plus/i.test(attributeText(current))) return true;
      current = current.parentElement;
    }

    return false;
  }

  function isRendered(element) {
    if (!element || !element.getBoundingClientRect) return false;

    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();

    return style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      parseFloat(style.opacity || '1') > 0.01 &&
      rect.width > 1 &&
      rect.height > 1;
  }

  function nativeCheckout(scope) {
    if (!scope) return null;

    return scope.querySelector(
      '[data-minicart-checkout-button], .pg-cart__checkout-btn'
    );
  }

  function onwardPrimary(scope) {
    if (!scope) return null;

    var controls = scope.querySelectorAll(
      'a, button, [role="button"], input[type="button"], input[type="submit"]'
    );

    for (var index = 0; index < controls.length; index += 1) {
      var control = controls[index];
      if (!isRendered(control) || control.matches('[data-minicart-checkout-button], .pg-cart__checkout-btn, [data-pg-uk-native-generated="true"]')) continue;

      var label = textOf(control);
      if (!label) continue;
      if (/continue without|view full cart|continue shopping|apple pay|google pay|klarna|shop pay|paypal/i.test(label)) continue;
      if (!hasOnwardContext(control, scope)) continue;

      var rect = control.getBoundingClientRect();
      if (rect.width >= 140 && rect.height >= 32) return control;
    }

    return null;
  }

  function syncScope(scope) {
    if (!scope) return;

    var controls = scope.querySelectorAll(
      'a, button, [role="button"], input[type="button"], input[type="submit"]'
    );

    Array.prototype.forEach.call(controls, function (control) {
      if (!/continue\s+without/i.test(textOf(control))) return;
      control.classList.add('pg-onward-optout-link');
      control.setAttribute('data-pg-onward-optout', '');
    });

    var onward = onwardPrimary(scope);
    var nativeButton = nativeCheckout(scope);

    if (onward) {
      onward.classList.add('pg-onward-primary-cta');
      onward.removeAttribute('data-pg-uk-onward-secondary');
      if (nativeButton) nativeButton.classList.add('pg-native-checkout-hidden-when-onward');
      scope.setAttribute('data-pg-onward-active', 'true');
    } else {
      if (nativeButton) nativeButton.classList.remove('pg-native-checkout-hidden-when-onward');
      scope.removeAttribute('data-pg-onward-active');
    }
  }

  function syncAll() {
    syncTimer = null;
    syncScope(document.querySelector('.cart_content'));
    syncScope(document.querySelector('#pg-cart .pg-cart__summary'));
  }

  function scheduleSync(delay) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncAll, delay == null ? 0 : delay);
  }

  function importedClone(node) {
    return document.importNode ? document.importNode(node, true) : node.cloneNode(true);
  }

  function patchNode(currentForm, freshForm, selector) {
    var currentNode = currentForm.querySelector(selector);
    var freshNode = freshForm.querySelector(selector);

    if (currentNode && freshNode) {
      currentNode.replaceWith(importedClone(freshNode));
      return true;
    }

    if (currentNode && !freshNode) {
      currentNode.remove();
      return true;
    }

    return false;
  }

  function patchMiniCartForm(currentForm, freshForm) {
    var currentItems = currentForm.querySelector('.cart_items.js-cart_items');
    var freshItems = freshForm.querySelector('.cart_items.js-cart_items');

    if (!currentItems || !freshItems) return false;

    ['data-total-discount', 'data-money-format', 'data-shop-currency', 'data-shop-name']
      .forEach(function (attribute) {
        if (freshForm.hasAttribute(attribute)) {
          currentForm.setAttribute(attribute, freshForm.getAttribute(attribute));
        } else {
          currentForm.removeAttribute(attribute);
        }
      });

    currentForm.classList.toggle('hidden', freshForm.classList.contains('hidden'));

    PATCH_SELECTORS.forEach(function (selector) {
      patchNode(currentForm, freshForm, selector);
    });

    currentForm.setAttribute('data-pg-cart-form-preserved', 'v17');
    currentForm.dispatchEvent(new CustomEvent('pg:cart-form-patched', {
      bubbles: true,
      detail: { source: 'pg-cart-onward-stability-v17' }
    }));

    document.dispatchEvent(new CustomEvent('cart:refresh', {
      detail: { source: 'pg-cart-onward-stability-v17' }
    }));


    [0, 80, 220, 600, 1200, 2500].forEach(function (delay) {
      window.setTimeout(syncAll, delay);
    });

    return true;
  }

  function stableReplaceWith() {
    var replacements = Array.prototype.slice.call(arguments);
    var replacement = replacements.length === 1 ? replacements[0] : null;

    if (
      this instanceof Element &&
      this.matches(MINI_CART_FORM) &&
      replacement instanceof Element &&
      replacement.matches(MINI_CART_FORM) &&
      patchMiniCartForm(this, replacement)
    ) {
      return;
    }

    return nativeReplaceWith.apply(this, replacements);
  }

  function installReplaceGuard() {
    if (Element.prototype.replaceWith === stableReplaceWith) return;

    Object.defineProperty(Element.prototype, 'replaceWith', {
      configurable: true,
      enumerable: false,
      writable: true,
      value: stableReplaceWith
    });
  }

  function mutationTouchesCart(mutation) {
    var target = mutation.target && mutation.target.nodeType === 1
      ? mutation.target
      : mutation.target && mutation.target.parentElement;

    if (target && target.closest && target.closest('.cart_content, #pg-cart')) return true;

    return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
      return node instanceof Element && (
        node.matches('.cart_content, #pg-cart') ||
        Boolean(node.querySelector('.cart_content, #pg-cart'))
      );
    });
  }

  function init() {
    installReplaceGuard();
    syncAll();

    document.addEventListener('cart:refresh', function () { scheduleSync(20); });
    document.addEventListener('pg:cart-form-patched', function () { scheduleSync(0); });
    document.addEventListener('shopify:cart:lines-update', function (event) {
      if (event && event.promise && typeof event.promise.then === 'function') {
        event.promise.then(function () { scheduleSync(0); }, function () { scheduleSync(0); });
      } else {
        scheduleSync(40);
      }
    });
    document.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest('.cart_content, #pg-cart')) {
        scheduleSync(80);
      }
    }, true);

    if (window.jQuery) {
      window.jQuery(document).on('cart.requestComplete', function () { scheduleSync(20); });
    }

    if (window.MutationObserver && document.body) {
      observer = new MutationObserver(function (mutations) {
        if (mutations.some(mutationTouchesCart)) scheduleSync(20);
      });
      observer.observe(document.body, { childList: true, characterData: true, subtree: true });
    }

    [100, 350, 900, 1800, 3500, 7000].forEach(function (delay) {
      window.setTimeout(syncAll, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
